import React, { Component } from 'react';
import { FormError } from '../FormError';
import { FormErrors } from '../FormErrors';
import CountriesAndStates from './../helper/CountriesAndStates';
import { Link, Redirect } from 'react-router-dom';
import { FormControl, FormGroup, ControlLabel } from 'react-bootstrap';

class CorporateToS extends Component {

  constructor (props) {
    super(props);
    this.audioCaptcha = React.createRef();
    this.audioSrc = React.createRef();
  }


  getValidationState = (isValid) => {
	if(isValid === '' || isValid == null){
      return null;
    }
    if(isValid){
      return 'success';
    }
    else{
      return 'error';
    }
  }

  hideClass = () => {
      if(this.props.submissionSuccesMessage===''){
          return 'hide';
      }
      else{
          return 'show';
      }
  }

  playClip = () =>{
    const audioElement = this.audioCaptcha.current;
  	audioElement.pause();
   	audioElement.load();
  	audioElement.play();
  };

  errorClass(isValid) {
      if(isValid === ''){
        return null;
      }
      if(isValid){
        return 'success';
      }
      else{
        return 'has-error';
      }
  }



  render() {
      var audioUrl = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/captcha/audio?v="+Date.now();

      return(
      <div className="container-fluid content-wrapper">
        <div className="row padTop padBottom">
          <div className="container">
            <div className="row">
              <div id="registrationCorporateContactInfo">
                  { (this.props.userCreationSucceeded) &&
                      <Redirect exact to="/confirmation"/>
                  }
                  {(!this.props.isCorporatePageValid()) &&
                      <Redirect exact to="/corporate"/>
                  }

                <div className="join-title padBottom col-12">
                  <h1 className="title-common primary">Create An Corporate Account</h1>
                  <p className="introText">Step 2 of 2</p>
                </div>
                <div className="col-12">
                  <form onSubmit={this.props.handleSubmit}>
                    <FormErrors className="genericErrorMessages" formErrors={this.props.genericFormLevelProblems} />
                    <FormGroup>
                      <label>CONTACT INFORMATION</label>
                    </FormGroup>
                    <FormGroup
                      controlId="formBasicTextPhone"
                      validationState={this.getValidationState(this.props.phone.isValid)}>
                      <ControlLabel>Phone <strong className="text-red"> *</strong></ControlLabel>
                      <FormError id="phone-error" errorMessage={this.props.phone.message } />
                      <FormControl
                        name="phoneNumber"
                        type="text"
                        value={this.props.phone.value}
                        onChange={this.props.handleUserInput}
                        maxLength="30"
                        aria-required="true"
                        aria-describedby="phone-error"
                        {...(this.props.phone.hasErrorFocus) &&
                          {className:'elementFocus'}
                        }
                      />
                    </FormGroup>
                    <FormGroup
                      controlId="formBasicTextAddress"
                      validationState={this.getValidationState(this.props.address.isValid)}>
                      <ControlLabel>Street Address <strong className="text-red"> *</strong></ControlLabel>
                      <FormError id="address-error" errorMessage={this.props.address.message } />
                      <FormControl
                        name="address1"
                        type="text"
                        value={this.props.address.value}
                        onChange={this.props.handleUserInput}
                        maxLength="100"
                        aria-required="true"
                        aria-describedby="address-error"
                        {...(this.props.address.hasErrorFocus) &&
                          {className:'elementFocus'}
                        }
                      />
                    </FormGroup>
                    <FormGroup
                      controlId="formBasicTextCity"
                      validationState={this.getValidationState(this.props.city.isValid)}>
                      <ControlLabel>City <strong className="text-red"> *</strong></ControlLabel>
                      <FormError id="city-error" errorMessage={this.props.city.message } />
                      <FormControl
                        name="city"
                        type="text"
                        value={this.props.city.value}
                        onChange={this.props.handleUserInput}
                        maxLength="30"
                        aria-required="true"
                        aria-describedby="city-error"
                        {...(this.props.city.hasErrorFocus) &&
                          {className:'elementFocus'}
                        }
                      />
                    </FormGroup>

                      <CountriesAndStates updateSelectedState={this.props.setSelectedState} updateSelectedCountry={this.props.setSelectedCountry} updateSelectedNonUSState={this.props.setSelectedNonUSState}
      			                countryError={this.props.country.message} usStateError={this.props.usState.message} nonUSStateError={this.props.nonUSState.message}
      			                selectedCountry={this.props.country.value} selectedState={this.props.usState.value} selectedNonUSState={this.props.nonUSState.value}
      			                  errorClass={this.errorClass()} showUSStatesDropdown={this.props.showUSStatesDropdown}/>

                    <FormGroup
                      controlId="formBasicTextZipCode"
                      validationState={this.getValidationState(this.props.zip.isValid)}>
                      <ControlLabel>Zip/Postal Code <strong className="text-red"> *</strong></ControlLabel>
                      <FormError id="zip-error" errorMessage={this.props.zip.message} />
                      <FormControl
                        name="postalCode"
                        type="text"
                        value={this.props.zip.value}
                        onChange={this.props.handleUserInput}
                        maxLength="10"
                        aria-required="true"
                        aria-describedby="zip-error"
                        {...(this.props.zip.hasErrorFocus) &&
                          {className:'elementFocus'}
                        }
                      />
                    </FormGroup>

                    <FormGroup className="help-block"
                    validationState={this.getValidationState(this.props.captcha.isValid)}>
                        <div id="captcha" className="framePanel captchaBgColor">
                          <span><img id="captchaImage" src={this.props.captcha.image} alt="captcha" tabIndex="0"/></span>
                          <a href="#/individualToS" id="captchaRefresh" onClick={this.props.refreshCaptcha} aria-label="Click on Refresh Button to get New Captcha" ><span className="fas fa-sync-alt"></span></a>
                          <a href="#/individualToS" id="captchaAudio" onClick={this.playClip} aria-label="Click on Audio Button to play Captcha" ><span className="fa fa-headphones"></span></a>
                        </div>
                        <audio id="audioCaptcha" ref={this.audioCaptcha} >
                            <source id="audioSrc" ref={this.audioSrc} src={audioUrl} type="audio/wav" />
                        </audio>
                    </FormGroup>

                    <FormGroup className="help-block"
                    validationState={this.getValidationState(this.props.captcha.isValid)}>
                        <label htmlFor="text_captcha">Enter text seen in above image here <strong className="text-red"> *</strong></label>
                        <FormError id="captcha-error" errorMessage={this.props.captcha.message} />
                        <FormControl id="text_captcha" name="captcha" type="text"
                        value={this.props.captcha.answer}
                        onChange={this.props.handleUserInput}
                        maxLength="100"
                        aria-required="true"
                        aria-describedby="captcha-error"
                        {...(this.props.captcha.hasErrorFocus) &&
                          {className:'elementFocus'}
                        }
                        />
                    </FormGroup>
                    <hr/>

                    <FormGroup>
                        <p><strong>TERMS &amp; CONDITIONS</strong></p>
                        <div className="row">
                          <div className="col-12">
                            <p>
                              <strong>NOTE:</strong>
                              By clicking Create Account button below, you agree to the &nbsp;
                              <a href="/firstnet/firstnet-developer-program-terms-and-condition" target="_blank">FirstNet Developer Terms and Conditions</a>.
                            </p>
                          </div>
                          <div className="col-12">
                            <p>After clicking submit, please look for an email from FirstNet Developer Program to validate your email address. Your account will not be functional until you validate your email address.</p>
                          </div>
                        </div>
                    </FormGroup>
                    <hr/>

                    <FormGroup className="col-12">
                        <div class="row">
                            <div className="col-6 text-right">
                                <Link to="/corporate" className="button secondary light-bg variableWidth previous" role="button">Go Back</Link>
                            </div>
                            <div className="col-6">
                                <input type="submit" className="button primary light-bg variableWidth" value="Create Account" />
                            </div>
                        </div>
                    </FormGroup>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CorporateToS;



// WEBPACK FOOTER //
// ./src/registration/CorporateToS.js